
import { SelectedFiltersBase } from '../selected-filters-base';

import './style.scss';

interface IProps {
  isVacationRentals?: boolean | null | undefined;
  isCars?: boolean | null | undefined;

  onFiltersOrSortChange: (isStoreChanged?: boolean) => void;
}

export function SelectedFiltersFooter(props: IProps) {
  const { isVacationRentals, isCars, onFiltersOrSortChange } = props;

  return (
    <SelectedFiltersBase 
      title="selectedFilters.footer"
      isVacationRentals={isVacationRentals}
      isCars={isCars}
      onFiltersOrSortChange={onFiltersOrSortChange}
      displayClearAll
      isCentered
    />
  );
}
